import React from 'react';
import { getRandomNumberFromInterval } from '~/utils/numbers';

import { ListStyled, EmptyCard } from './styles';

export const LoadingScreen = (): JSX.Element => {
  const randomSpans = [...Array(20)].map((x, index) => {
    return { value: getRandomNumberFromInterval(6, 12), key: index };
  });
  return (
    <ListStyled>
      {randomSpans.map((span) => {
        return <EmptyCard key={span.key} className={`span-${span.value}`} />;
      })}
    </ListStyled>
  );
};
